module.exports = __webpack_public_path__ + "media/application/images/icons/close-green-9c06b29262f909c66a7de996dc67d9a7.svg";